module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "aria-labelledby": "ch02_hd",
      "role": "doc-chapter"
    }
  }, [_c('h2', {
    staticClass: "h2chap",
    attrs: {
      "id": "ch02_hd"
    }
  }, [_vm._v("CHAPTER 2: MOTHER")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "stickup"
  }, [_vm._v("O")]), _c('span', {
    staticClass: "f1"
  }, [_vm._v("n the walk")]), _vm._v(" back to the campsite, Rovender listened while Eva explained her dilemma.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So the pilot, Hailey, tells you that you must retrieve your Omnipod in order for you to gain entrance to the human village, New Attica?” he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah, pretty much.” Eva pouted and kicked rocks out of her way.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And what is your impression of this other human?” said Rovender as they walked under the broken arch at the entrance of their camp.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Eva gave pause, mostly because she wasn’t sure what her impression was just yet. “He’s okay, I guess…. I don’t know,” she said, twisting a bead on one of her braids. “I mean, he’s here to rescue us and take us to the city, right? But he’s also telling "), _c('span', {
    attrs: {
      "aria-label": "page 22",
      "id": "page_22",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("me I have to go find my Omnipod buried out there in a sniper-infested desert. Why can’t we just leave without it?” She exhaled hotly.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Rovender stopped and lifted Eva’s chin. With indigo eyes he studied her. “Eva, I recognize your confusion. It is not always easy to understand another’s spirit, especially if you do not know where to look.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He looks like a nice guy,” Eva said. “Well, except that he is a bit dirty.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No, no, no. That is not what I mean,” Rovender said. “When we first met, I certainly did not know what to make of you. And likely you felt the same about me, correct?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You yelled at me and snatched away my Omnipod.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Rovender grinned. “I admit, I thought the device to be some form of weapon.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And you kept telling me how you needed to go and how I was on my own,” said Eva. Her voice became more thoughtful with recollection. “But then you stayed. You helped me. You helped Muthr. I couldn’t have survived out here if it weren’t for you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So, Eva Nine, you must sometimes disregard what one is "), _c('i', [_vm._v("saying")]), _vm._v(" and focus instead on what they "), _c('span', {
    attrs: {
      "aria-label": "page 23",
      "id": "page_23",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("are "), _c('i', [_vm._v("doing")]), _vm._v(". Watch and observe. That is when one reveals his true self. Do you understand?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Eva nodded.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“This Hailey knows the rules of your people. He tells you that he is trying to make it easy for you to become one with the human village.” Rovender continued walking.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So I just do what he says, then?” Eva asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“If your desire is to gain access to this New Attica, then we must trust him until his actions prove otherwise,” Rovender said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("Yes. Maybe he’s just eager to leave too")]), _vm._v(", Eva thought, her mind somewhat at ease. "), _c('i', [_vm._v("He was awfully busy fixing his ship")]), _vm._v(". She sat on the wing of Besteel’s parked glider and began twirling one of her thin braids around her finger. “But how are we going to find my Omnipod? You saw what happened out there.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I understand. All of this makes you upset,” said Rovender.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I just don’t want to go back to that… place.” Eva said. Thoughts of Muthr and Besteel’s attack bombarded her all at once. “It’s too much. I can’t.” The braid was wound so tight that her fingertip was red.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Rovender brushed away Eva’s bangs. “Have you "), _c('span', {
    attrs: {
      "aria-label": "page 24",
      "id": "page_24",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("told Hailey what happened to your Omnipod?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Eva lied. “No. I didn’t want to trouble him. He seemed busy working on his ship.” She wished that Hailey had not said the things he’d said. She wanted him to not think of her as some helpless “reboot.” She wanted to slap her Omnipod into his hand and prove to him how strong, smart, and resourceful she was. But that wasn’t going to happen. Her Omnipod was down in the gut of some monstrous sand-sniper.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You wait here, okay?” Rovender grabbed his walking stick and donned his wide-brimmed hat.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No, Rovee.” Eva let go of her braid. “Don’t go. It’s too dangerous. You saw the size of that sand-sniper. It’s not worth it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It is worth it to you, so it is worth it to me,” Rovender said, grabbing his bottle of water. “We have until sundown, correct? I will go take a look around and see what clues may be found.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And if you come across a sniper?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I shall be protected.” Rovender pulled out from the glider’s saddlebag a holster holding a large sonic pistol. He tucked the weapon snug into his belt. “Now you wait here and get some rest.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Eva handed Rovender his saggy rucksack. “No way are you going out there alone. I’m coming with you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    attrs: {
      "aria-label": "page 25",
      "id": "page_25",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("“Very well. At least this way I can keep an eye on you.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Eva strapped her satchel on, her mind turning over what Rovender had said earlier. “Rovee?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, Eva Nine?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why did you decide to help me? I mean, how did you know the difference between what I was saying and what I was doing?” asked Eva.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Rovender knelt down in front of her. “Despite what we see and hear, there is a voice that will always be truthful to you,” he replied. Rovender spread an open palm over Eva’s heart. “If you listen from here, you will never be misled.”")]), _vm._v(" "), _c('hr', {
    staticClass: "secbreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The glaring noonday sun baked the sand-worn remains of the ancient city. Rovender and Eva found themselves on the outskirts of the ruins facing endless dunes that stretched out in every direction. The hot breath of gusty wind whipped at Eva, covering her feet in loose granules of ashen sand. Not even the climatefiber in her utilitunic could keep her body cool.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“There is no way on Orbona that we are going to find this thing,” Eva said, rubbing the sand from her eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Be patient.” Rovender placed his hat on Eva’s "), _c('span', {
    attrs: {
      "aria-label": "page 26",
      "id": "page_26",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("head and climbed up onto a large piece of eroded rubble. He peered through his spyglass. “Perhaps luck may pay us a visit.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Eva stared out into the wasteland. It was like a sea of sand. And, just like the great lake near Lacus, the surface undulated and rolled with the blowing wind.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hmmm.” Rovender continued to scan the horizon. “I was hoping for some kind of tracks from Otto’s herd or a sinkhole from the sniper. But all is gone. Buried.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Eva wiped the sweat from her forehead and sipped her water. She sat on the rubble where Rovender was perched and suddenly recognized its shape and form. He was standing on the rusted carriage of a half-buried hovercraft. It was similar to the old golden hovercraft Eva had piloted over these wastelands. A thought came to her. “Rovee, look for the Goldfish.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, yes, yes,” Rovender sang as he scanned the horizon. “Your hover-machine. That is a good idea, Eva Nine. A very good idea…. Aha!” He pointed out into the distance. “I see it! The Goldfish is this way.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The two trudged along in the blistering heat at the edge of the ruins, careful to avoid the open "), _c('span', {
    attrs: {
      "aria-label": "page 27",
      "id": "page_27",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("sandy dunes where snipers preyed just below the surface. As Rovender and Eva moved closer to the wreck of the Goldfish, Eva felt weird, like she was rewinding a program—a program she wasn’t ready to revisit just yet.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oeeah! What have we here?” Rovender knelt down to examine something.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Is it my Omnipod?” Eva rushed up to him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I do not think so.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lying before them was a gooey sand-speckled blob about the size of Eva. Strange flies and unusual insects buzzed around it as they lapped up the milky goo that oozed from the cracks of the blob’s dried skin. Rovender jabbed the viscous mass with his walking stick. The end of his stick caught on something inside the blob, and he tugged on it. From the mass came a coiled wire, which Rovender seized with his hand and began to pull out.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What is that?” Eva winced. Now that Rovender was digging around in the goo, a nauseating stench drifted up amidst the swarm of flies.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I believe it is a clue,” he replied as he yanked on the coiled wire. Finally, from deep within, he pulled out a familiar artifact.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s Besteel’s boomrod!” Eva said in shock.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Indeed it is.” Rovender dropped the huntsman’s "), _c('span', {
    attrs: {
      "aria-label": "page 28",
      "id": "page_28",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("weapon back into the mass. “It is as I suspected. Sand-snipers cannot digest metal or other similar materials. Do you remember the one near your old home that spit out my bottle?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I do.” Eva flinched. “So, is my Omnipod in that?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Perhaps.” Rovender wiped his hands on his tattered jacket. “But we’ll have to dig through this spittle to know for sure.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The disgusting stink wafted back up, whirling around Eva.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m not digging in that.” She wagged her finger at the blob. “I’ll puke.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But, Eva Nine, your device may lie in there,” Rovender countered.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Eva brightened and pulled out from her satchel the old Omnipod that Hailey had given her. “Hold on. Perhaps Hailey’s old one can tell us for sure if it’s in there.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“A good idea,” Rovender said, and dribbled water over his hands to cleanse them.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Eva activated the old Omnipod, and the lights flickered for several long moments before it finally came on.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Greetings, Van Turner,” the Omnipod said through a static-filled hiss. Eva and Rovender "), _c('span', {
    attrs: {
      "aria-label": "page 29",
      "id": "page_29",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("exchanged glances. The device continued, “How may I be of service?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Can you locate the whereabouts of another Omnipod?” Eva asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Initiating Techscan,” the device replied. A flickering radar map projected over its central eye. “There is a faint signal approximately ninety meters to the northeast,” it reported. “It carries a trace signal similar to an Omnipod. However, it is too far away to tell for sure at your current coordinates. Please rescan when you are in closer proximity.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What about in this glop right here?” Eva pointed the Omnipod’s eye at the mass that held Besteel’s boomrod.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Omnipod was silent for some time. At last it said, “There is Tech here that I cannot identify. It does not carry the signal of an Omnipod.” Eva put the old device away and looked at Rovender.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Let us continue,” he said, and set out over the dunes in the direction the old Omnipod had instructed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As the debris of the ruins became sparser, Eva spotted something glimmering in the sun. The duo ventured toward a golden fin rising out of the sand like a hologram of a swimming shark.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    attrs: {
      "aria-label": "page 30",
      "id": "page_30",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("It was the rudder of the Goldfish.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We can go no farther until we find out if there are any snipers present,” said Rovender. He began thumping the ground around the wreck with his walking stick. “This vibration will attract them if any are present, but you may also want to use that Omnipod as well.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Eva crumpled down to the blazing ground next to the golden fin and clutched handfuls of hot sand. In one night the entire hovercraft had been almost completely buried in sand, save for the lone tail rudder. However, the events—Muthr’s intercepting Besteel’s lethal shot—were still fresh in Eva’s memory.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Rovender knelt down next to Eva and put his arm around her. “Are you all right?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah.” She wiped her eyes with her sleeve. “I just want to get out of here.” She took out the old Omnipod and commanded, “Initiate LifeScan, please.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The hissy voice of the old Omnipod replied, “LifeScan is inoperative at this moment. Aspects of the program’s database appear corrupted. Please hold while I attempt program analysis and repair.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Great! That’s just great!” Frustrated, Eva threw the old Omnipod back into her satchel. “Doesn’t anything work?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    attrs: {
      "aria-label": "page 31",
      "id": "page_31",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("“Patience, Eva Nine,” Rovender said, leaning on his stick.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m tired of being patient! I’m tired of waiting!” Now furious, she stomped around the wreckage as the sweltering heat hammered down. It felt as if the sandy ocean itself had been brought to a boil.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Eva,” Rovender called out to her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She ignored him and continued yelling. “It’s all everybody ever tells me. ‘Wait for this!’ ‘Be patient for that!’ ”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Eva!” Rovender called out again.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“WHAT!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Do. Not. Make. A. Move,” Rovender whispered, and pointed behind her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Eva turned to see an enormous sand-sniper towering overhead. The monster was an impossibly large, sand-colored crustacean armed with an arsenal of spiked claws and barbed graspers. At its head two bowl-shaped eyes moved independently of each other amidst an array of corded feelers and paddle-shaped antennae. The sniper was accompanied by its brood of clacking, snapping nymphs.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d15c2cd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781442450844/xhtml/ch02.vue
// module id = 84
// module chunks = 0